import { AppSelectProps } from 'components/app-select';
import { useCallback } from 'react';
import { ControllerFieldState, ControllerRenderProps, UseFormStateReturn } from 'react-hook-form';
import { decorateAfter, fieldToLabelKey } from 'utils/other';
import { useTranslate } from './use-translate';

interface Options {
  field: ControllerRenderProps<any, any>;
  fieldState: ControllerFieldState;
  formState: UseFormStateReturn<any>;
}

interface Props extends Partial<AppSelectProps<any, any, any, any>> {}

export const useFilterSelectProps = (props?: Props) => {
  const { t } = useTranslate();
  return useCallback(
    (options: Options) => {
      const { field } = options;
      const valueArrayHas = Array.isArray(field.value) && field.value.length;
      return {
        ...props,
        RenderInputProps: {
          ...props?.RenderInputProps,
          InputLabelProps: {
            ...props?.RenderInputProps?.InputLabelProps,
            shrink: true,
          },
        },
        ...field,
        label: t(fieldToLabelKey(field.name)),
        placeholder: valueArrayHas ? undefined : t('all'),
        onChange: decorateAfter(field.onChange, props?.onChange),
      };
    },
    [props, t],
  );
};
